import { render, staticRenderFns } from "./UploadAttachmentForm.vue?vue&type=template&id=7bf3aa2c&scoped=true"
import script from "./UploadAttachmentForm.vue?vue&type=script&lang=js"
export * from "./UploadAttachmentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf3aa2c",
  null
  
)

export default component.exports